<template>
  <div>
    <div class="scroll-wrapper">
      <b-card style="background-color:#F5F7F8;" class="scroll">
        <div :class="{'card-container': !hasComparisonData, 'card-container-after': hasComparisonData}">
          <b-card-group class="card-wrapper" deck>
            <b-card v-if="hasComparisonData" class="custom-card sticky-card">
              <p ></p>
            </b-card>

            <!-- CARD TELKOM  -->
            <b-card class="custom-card sticky-card-top" @click="openModal('telkom')">
              <div :class="{'dashed-border': selectedCategory === '', 'no-border': selectedCategory !== ''}" >
                <b-card-text class="b-card-text">
                  <b-img :src="telkomImg" class="img-logo" />
                  <hr v-if="selectedCategory !== ''"/>
                  <b-img v-if="selectedCategory === ''" :src="plusIcon" class="icon-plus" />
                  <h3 v-else class="selected-category" style="color:red; font-weight: 800"><b>{{ selectedCategory }}</b></h3>
                  <p v-if="selectedCategory === ''" class="card-text">Pilih Produk</p>
                </b-card-text>
              </div>
            </b-card>


            <!-- CARD TELKOM  -->
            <b-card class="custom-card sticky-card-top" @click="openModal('competitor', 0)">
              <div :class="{'dashed-border': selectedCompetitor[0] === undefined, 'no-border': selectedCompetitor[0] !== undefined}">
                <b-card-text class="b-card-text">
                  <b-img
                    class="img-logo"
                  />
                  <b-img v-if="selectedCompetitor[0] !== undefined" 
                    @click.stop="removeCompetitor(0)" 
                    :src="xIcon"
                    style="position: absolute; top: 10px; right: 10px; cursor: pointer; width:25px"
                    alt="Remove Competitor"/>
                  <b-img v-if="disabledIcon === true" :src="plusDisabledIcon" class="icon-plus"/>
                  <b-img v-else-if="disabledIcon === false && selectedCompetitor[0] === undefined" :src="plusDis" class="icon-plus"/>
                  <b-img style="margin-top:35px" v-else="disabledIcon === false && selectedCompetitor[0] !== undefined" 
                  :src="require(`@/assets/images/competitor/${selectedCompetitor[0]}.png`)" 
                  class="selected-category img-logo-competitor" 
                  alt="Selected Competitor"/>
                  <p v-if="selectedCompetitor[0] == undefined" >Pilih Competitor</p>
                </b-card-text>
              </div>
            </b-card>

            <b-card class="custom-card sticky-card-top" v-for="(competitor, index) in competitorData"
            :key="index + 1" @click="openModal('competitor', index + 1)">
              <div :class="{'dashed-border': selectedCompetitor[index + 1] === undefined, 'no-border': selectedCompetitor[index + 1] !== undefined}" v-if="selectedCompetitor[index] !== undefined" >
                <b-card-text class="b-card-text">
                  <b-img v-if="selectedCompetitor[index + 1] !== undefined" 
                    :src="xIcon" 
                    alt="Remove Competitor" 
                    class="icon-x" 
                    style="position: absolute; top: 10px; right: 10px; cursor: pointer; width:25px"
                    @click.stop="removeCompetitor(index + 1)" />
                  <b-img v-if="selectedCompetitor[index + 1] === undefined" :src="plusDis" class="icon-plus"/>
                  <b-img style="margin-top:35px" v-else="disabledIcon === false && selectedCompetitor[index + 1] !== undefined" 
                  :src="require(`@/assets/images/competitor/${selectedCompetitor[index + 1]}.png`)" 
                  class="selected-category img-logo-competitor" 
                  alt="Selected Competitor"/>
                  <p v-if="disabledIcon === false && selectedCompetitor[index + 1] == undefined" >Pilih Competitor</p>
                </b-card-text>
              </div>
            </b-card>
            
          </b-card-group>
        </div>
        

        <!-- FORM REPEATER -->
        <div :class="{'card-container': !hasComparisonData, 'card-container-after': hasComparisonData}" v-if="hasComparisonData">
          <b-card-group
            class="card-wrapper"
            deck
            v-for="(specification, index) in specifications"
            draggable="true"
            @dragstart="handleDragStart(index)"
            @dragover.prevent
            @drop="handleDrop(index)"
          >
            <b-card 
              class="custom-card-table sticky-card" 
              img-alt="Image"
              img-top
            >
              <b-form-select
                @change="handleChangeService(specification.serviceType)"
                v-model="specification.serviceType"
                :options="serviceSpecifications" 
                :id="'select-serviceType' + index">
              </b-form-select>
            </b-card>
            <b-card 
              v-for="(provider, providerIndex) in comparisonData"
              :key="providerIndex" 
              img-alt="Image"
              img-top
              class="custom-card-table"
              > 
              <b-input-group class="mb-2">
                <b-form-input 
                  :id="'input-value-' + index" 
                  v-model="specification.values[providerIndex].input"
                  required>
                </b-form-input>
                <!-- v-if="['Delivery Time', 'Bandwidth'].includes(this.category)" -->
                <!-- v-model="specification.format[providerIndex]" -->
                <b-form-select 
                  v-if="showOptionsForServiceType(specification.serviceType)"
                  :options="getOptionsForCategory(specification.serviceType)"
                  v-model="specification.values[providerIndex].select"
                  :id="'select-value' + index">
                </b-form-select>
              </b-input-group>
            </b-card>
          </b-card-group>
        </div>
        
      </b-card>
      <!-- BTN BANDINGKAN PRODUCT -->
      <b-button v-if="hasComparisonData" @click="addSpecification" class="icon-button" variant="primary">
        <feather-icon size="18" icon="RepeatIcon" />
      </b-button>
      <!-- <p v-if="hasComparisonData" class="source-bottom"><i>@Telkom Competitive Pricing Report 2023</i></p> -->
    </div>

    <!-- BTN RESET -->
    <div>
      <div class="d-flex justify-content-center mt-3">
        <b-button v-if="hasComparisonData" @click="submitData" variant="success">Kirim Data</b-button>
        <b-button v-if="!hasComparisonData" @click="handleCompare" variant="primary">Continue For Create This Comparison</b-button>
      </div>
    </div>

    <!-- MODAL ADD TELKOM -->
    <b-modal modal-class="modal-product" title="Pilih produk" v-model="isModalOpen">
      <b-form-group>
        <b-form-select v-model="selectedOption" :options="categoriesProduct"></b-form-select>
      </b-form-group>
      <template #modal-footer>
        <div class="text-center gap-2 w-100">
          <b-button variant="secondary" @click="isModalOpen = false" class="mr-2">Close</b-button>
          <b-button variant="primary" @click="selectCategory">OK</b-button>
        </div>
      </template>
    </b-modal>
    
    <!-- MODAL ADD KOMPETITOR -->
    <b-modal modal-class="modal-competitor" v-model="isModalCompetitor" title="Pilih Competitor">
      <b-form-group>
        <b-form-select v-model="selectedCompetitorOptions" :options="categoriesCompetitors">
          <template #option="option">
            <span v-if="option.disabled">
              {{ option.text }} test
            </span>
            <span v-else>{{ option.text }} benar</span>
          </template>
        </b-form-select>
      </b-form-group>
      <template #modal-footer>
        <div class="text-center w-100">
          <b-button variant="secondary" @click="isModalCompetitor = false" class="mr-2">Close</b-button>
          <b-button style="background-color:#10375C !important" @click="selectedCompetitors">OK</b-button>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import { BCard, BCardText, BImg, BCardGroup, VBModal, BFormSelect, BFormGroup, BButton, BRow, BCol, BContainer, BTable, BForm, BFormInput, BInputGroup } from 'bootstrap-vue'
  import { generateToken } from '@/auth/helperAuth'
  export default {
    components: { BCard, BCardText, BImg, BCardGroup, VBModal, BFormSelect, BFormGroup, BButton, BRow, BCol, BContainer, BTable, BForm, BFormInput, BInputGroup },
    data() {
      return {
        telkomImg: require('@/assets/images/logo_telkom horizontal.png'),
        plusIcon: require('@/assets/images/icons/adds.png'),
        plusDis: require('@/assets/images/icons/plusDis.png'),
        plusDisabledIcon: require('@/assets/images/icons/disabledPluss.png'),
        xIcon: require('@/assets/images/icons/remove.png'),
        disabledIcon: true,
        isModalOpen: false,
        isModalCompetitor: false,
        selectedOption: '',
        selectedCategory: '',
        selectedCompetitorOptions: '',
        selectedSpecificationsOptions: '',
        selectedCompetitor: [],
        categoriesCompetitors: [],
        serviceSpecifications: [],
        specificationInputValue: '',
        categoriesProduct: [],
        competitorData: [],
        currentCardIndex: null,
        comparisonData: {},
        specifications: [],
        serviceOptions: {},
        token:"",
        dragIndex: null
      }
    },
    created() {
      const payload = {
        client: "product-catalog-fe",
        kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
        user: this.$store.getters['oauth/getActiveUser'].name,
        role: this.$store.getters['oauth/getActiveUser'].role,
      };
      this.token = generateToken(payload)
    },
    mounted() {
      Promise.all([
        this.categories()
      ])
      this.fetchSpecifications()
    },
    computed: {
      hasComparisonData() {
        return Object.keys(this.comparisonData).length > 0
      },
    },
    methods: {
      handleChangeService(serviceType){
        this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list?table=service_specifications&page=1&perPage=10`, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(response => { 
          this.serviceOptions = response.data.data
            .filter(item => item.format.length > 0)
            .reduce((acc, item) => {
              const options = item.format.map(format => {
                let value = format.toLowerCase().replace(/ /g, '_')
                let text = `${format}`
                return { value, text }
              })
              acc[item.name] = options
              return acc
            }, {})
        })
      },
      showOptionsForServiceType(serviceType) {
        const data = [
          'Delivery Time (working days)',
          'Bandwidth',
          'Promised SLA',
          'Minimum Contract'
        ]
        return data.includes(serviceType)
      },
      getOptionsForCategory(serviceType) {
        return this.serviceOptions[serviceType] || []
      },
      handleDragStart(index) {
        this.dragIndex = index
      },
      handleDrop(index) {
        const draggedItem = this.specifications[this.dragIndex]
        this.specifications.splice(this.dragIndex, 1)
        this.specifications.splice(index, 0, draggedItem)
        this.dragIndex = null
      },
      submitData() {
        const payload = {
          data: []
        }
        this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list?table=service_type&search=TELKOM&page=1&perPage=0`, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(response => {
          this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list?table=service_specifications&page=1&perPage=0`, {
            withCredentials: true,
            headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
          })
          .then(spec => {
            let telkomSpec = {
              serviceType: this.selectedCategory,
              competitor_of: null,
              source: '',
              specification: []
            };

            const matchedCategory = response.data.data.find(sp => sp.name === this.selectedCategory)
            if (matchedCategory) {
              telkomSpec.competitor_of = matchedCategory.id
            }
            this.specifications.forEach((i, idx) => {
              const matchedTelkomSpec = spec.data.data.find(sp => sp.name === i.serviceType)
              if (matchedTelkomSpec) {
                const input = i.values['TELKOM']?.input || ''
                const select = i.values['TELKOM']?.select || ''
                const combinedValue = input && select ? `${input} ${select}` : input || select

                telkomSpec.specification.push({
                  id: matchedTelkomSpec.id,
                  label: i.serviceType,
                  value: combinedValue,
                  grouped: false,
                  groupedby: false,
                  sequence: idx,
                })
              }
            })

            payload.data.push(telkomSpec)
            for (let competitor of this.selectedCompetitor) {
              let competitorSpec = {
                serviceType: competitor,
                competitor_of: matchedCategory.id,
                source: '',
                specification: []
              }
              this.specifications.forEach((i, idx) => {
                const matchedSpec = spec.data.data.find(sp => sp.name === i.serviceType)
                if(matchedSpec){
                  const input = i.values[competitor]?.input || ''
                  const select = i.values[competitor]?.select || ''
                  const combinedValue = input && select ? `${input} ${select}` : input || select
                  competitorSpec.specification.push({
                    id: matchedSpec.id,
                    label: i.serviceType,
                    value: combinedValue,
                    grouped: false,
                    groupedby: false,
                    sequence: idx,
                  })
                }
              })
              payload.data.push(competitorSpec)
            }
            this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/competitor/comparison/save`, payload.data, {
              withCredentials: true,
              headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
            })
            .then(res => { 
              window.location.reload()
            })
            .catch(error => {
              console.error('Error fetching comparison data:', error);
            })
          })
        })
      },
      initializeSpecifications() {
        if (Object.keys(this.comparisonData).length) {
          this.specifications.push({
            serviceType: null,
            values: this.initializeValues(),
          })
          this.specifications.forEach(spec => {
            for (const key in this.comparisonData) {
              if (!spec.values[key]) {
                spec.values[key] = {
                  input: '',
                  select: ''
                };
              }
            }
          });
        }
      },
      initializeValues() {
        const values = {}
        for (const key in this.comparisonData) {
          if (this.comparisonData.hasOwnProperty(key)) {
            values[key] = {
              input: '',
              select: ''
            }
          }
        }
        return values
      },
      addSpecification() {
        if (Object.keys(this.comparisonData).length) {
          this.specifications.push({
            serviceType: null,
            values: this.initializeValues(),
            // format: null
          })
        } else {
          console.error('Comparison data is not loaded.')
        }
      },
      async categories(){
        let params = {
          table: "service_type",
          page: 1,
          perPage: 0,
          search: "TELKOM",
          order: 'DESC'
        }

        return await this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
          params: params,
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(response => { 
          const category = response.data.data.map(i=> {
            return i.name
          })
          this.categoriesProduct=category
        })
      },

      openModal(card, index = 0) {
        this.currentCardIndex = index
        if (card === 'telkom') {
          this.isModalOpen = true
        }
        else if (card === 'competitor') {
          this.isModalCompetitor = true
        }
      },

      selectCategory() {
        let params = {
          table: "service_type",
          page: 1,
          perPage: 0,
          search: "KOMPETITOR",
          order: 'DESC'
        }
        if (this.selectedCategory === '') {
          this.selectedCategory = this.selectedOption
          this.disabledIcon = false
          this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
            params: params,
            withCredentials: true,
            headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
          })
          .then(response => { 
            for(let cc of response.data.data){
              this.categoriesCompetitors.push({
                value: cc.name,
                text: cc.name
              })
            }
          })
        } else if (this.selectedCategory !== '' && Object.keys(this.comparisonData).length == 0){
          this.selectedCategory = this.selectedOption
          this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
            params: params,
            withCredentials: true,
            headers: { 'Client-Device': 'browser', 'Authorization': `${token}` },
          })
          .then(response => { 
            for(let cc of response.data.data){
              this.categoriesCompetitors.push({
                value: cc.name,
                text: cc.name
              })
            }
          })
        } else if(this.selectedCategory !== '' && Object.keys(this.comparisonData).length > 0){
          this.comparisonData = {}
          this.selectedCompetitor = []
          this.competitorData = []
          this.categoriesCompetitors = []
          this.selectedCompetitorOptions = ''
          this.selectedCategory = this.selectedOption
          this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
            params: params,
            withCredentials: true,
            headers: { 'Client-Device': 'browser', 'Authorization': `${token}` },
          })
          .then(response => { 
            for(let cc of response.data.data){
              this.categoriesCompetitors.push({
                value: cc.name,
                text: cc.name
              })
            }
          })
          params.search = "TELKOM"
          this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
            params: params,
            withCredentials: true,
            headers: { 'Client-Device': 'browser', 'Authorization': `${token}` },
          })
          .then(response => { 
            for(let cc of response.data.data){
              this.categoriesCompetitors.push({
                value: cc.name,
                text: cc.name
              })
            }
          })
          .catch(error => {
            console.error('Error fetching comparison data:', error)
          })
        }
        this.isModalOpen = false
      },

      selectedCompetitors() {
        this.$set(this.selectedCompetitor, this.currentCardIndex, this.selectedCompetitorOptions)
        if (this.currentCardIndex === this.competitorData.length) {
          this.competitorData.push({ competitorName: this.selectedCompetitor })
        }
        this.categoriesCompetitors.forEach((cc) => {
          if(this.selectedCompetitor.includes(cc.value)){
            cc.disabled = true;
          }
        })

        this.selectedCompetitorOptions = ''
        this.isModalCompetitor = false
        if(Object.keys(this.comparisonData).length > 0){
          this.handleCompare()
        }
      },

      handleCompare(){
        const collectCompetitor = []
        this.competitorData[0].competitorName.forEach((x) => {
          collectCompetitor.push(x)
        })
        const requestData = {
          category: this.selectedOption,
          competitor: collectCompetitor
        }

        this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/competitor/comparison`, requestData, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(res => { 
          this.comparisonData = res.data
          this.initializeSpecifications()
        })
        .catch(error => {
          console.error('Error fetching comparison data:', error);
        })
      },

      async fetchSpecifications() {
        let params = {
          table: "service_specifications",
          page: 1,
          perPage: 0,
          order: 'DESC'
        }

        return await this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
          params: params,
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(response => { 
          for(let ss of response.data.data){
            this.serviceSpecifications.push({
              value: ss.name,
              text: ss.name
            })
          }
        })
      },

      resetCompare(){
        this.comparisonData = {}
        this.selectedCategory = ''
        this.selectedOption = ''
        this.selectedCompetitor = []
        this.competitorData = []
        this.categoriesCompetitors = []
        this.disabledIcon = true
        this.currentCardIndex = null
        this.isModalOpen = false
        this.isModalCompetitor = false
        this.selectedCompetitorOptions = ''
      },

      removeCompetitor(index) {
        const competitorName = this.selectedCompetitor[index]
        if (index === 0) {
          this.$set(this.selectedCompetitor, 0, undefined)
          if (this.competitorData.length > 0) {
            this.competitorData.splice(0, 1)
          }
          this.selectedCompetitor = this.selectedCompetitor.filter((item, i) => i !== index)
          if (competitorName && Object.keys(this.comparisonData).length > 0) {
            if (this.comparisonData[competitorName]) {
              this.$delete(this.comparisonData, competitorName);
            }
          }
        } else {
          this.$set(this.selectedCompetitor, index, undefined)
          this.competitorData.splice(index - 1, 1)
          this.selectedCompetitor = this.selectedCompetitor.filter((item, i) => i !== index)
        }
        if (competitorName && Object.keys(this.comparisonData).length > 0) {
          if (this.comparisonData[competitorName]) {
            this.$delete(this.comparisonData, competitorName)
          }
        }
      },
    },
  }
</script>

<style scoped>

  .scroll-wrapper{
    position:sticky;
  }
  .scroll {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: auto;
  }

  .card-container {
    display: flex;
    justify-content: center;
    white-space:nowrap;
    overflow: auto;
  }

  .card-container-after {
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin-bottom: 20px;
  }

  .custom-card {
    min-width: 340px;
    height: 180px;
    overflow: hidden;
    margin: 0 1px;
    flex-shrink: 0; 
    flex-grow: 0; 
    cursor: pointer;
  }

  .card-wrapper {
    display: flex;
    flex-wrap: nowrap;
    max-height: 450px;
    max-width:100%;
  }

  .custom-card-table {
    min-width: 340px;
    height: 100%;
    overflow-y: hidden;
    flex-direction: column;
    margin: 0 1px;
    justify-content: space-between;
    flex-shrink: 0; 
    flex-grow: 0;
  }

  .custom-card-table p {
    margin: 0;
    line-height: 1.2;
  }

  .custom-card-table hr {
    margin: 10px 0;
  }

  .card-section {
    height: 20px;
  }

  .card-section-sdwan {
    height: 70px;
  }

  .card-section-wms {
    height: 150px;
  }

  .sticky-card {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    /* top:0; */
    z-index: 1;
  }

  /* .sticky-card-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #F5F7F8;
  } */

  .dashed-border {
    border: 2px dashed grey;
    border-radius:10px;
    padding: 10px;
    display: flex;
    /* opacity:29px; */
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .dashed-border-disabled {
    border: 3px dashed #E2F1E7;
    border-radius:10px;
    padding: 10px;
    display: flex;
    /* opacity:29px; */
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .b-card-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    text-align: center;
    flex-grow: 1;
  }

  .img-logo {
    width: 80%;
    max-height: 80px;
    object-fit: contain;
  }

  .img-logo-competitor {
    display: flex;
    width: 50%;
    max-height: 50px;
    justify-content: center;
    object-fit: contain;
    align-items: center;
    text-align: center;
  }

  .icon-plus {
    width: 40px;
    margin-top: 10px;
  }
  .icon-button {
    position: absolute;
    bottom: 40px;
    right: 10px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .source-bottom {
    position: absolute;
    bottom: 0;
    right: 10px;
    font-weight:600;
    color:grey;
  }
</style>
<style>
  .modal-product .modal-header {
    background-color: #dc3545 !important;
    color: white !important;
  }

  .modal-competitor .modal-header {
    background-color: #10375C !important;
    color: white !important;
  }
  .modal-title {
    color:white;
    font-weight:600
  }
  select option:disabled {
    color: black;
    background-color: #E7E8D8;
  }
</style>
